/*
* Common order values/functions
*/

export const OrderServiceLevelGroups = {
    Economy: { name: 'Economy', sort: 200 },
    Standard: { name: 'Standard', sort: 100 },
    Rush: { name: 'Rush', sort: 300 },
    Miscellaneous: { name: 'Miscellaneous', sort: 1000 },
};

export const OrderServiceLevelSortFromGroup = (servName: string): number => {
    let result = OrderServiceLevelGroups.Miscellaneous.sort;
    if (!servName) { return result; }

    switch (servName) {
        case OrderServiceLevelGroups.Standard.name:
            result = OrderServiceLevelGroups.Standard.sort;
            break;

        case OrderServiceLevelGroups.Economy.name:
            result = OrderServiceLevelGroups.Economy.sort;
            break;

        case OrderServiceLevelGroups.Rush.name:
            result = OrderServiceLevelGroups.Rush.sort;
            break;

        default:
            result = OrderServiceLevelGroups.Miscellaneous.sort;
            break;
    }

    return result;
};

export const BidLetterStateCodes = {
    Nevada: 'NV',
    California: 'CA',
    Utah: 'UT',
    Arizona: 'AZ',
};

export const BidLetterStateNameFromStateCode = (stateCode: string): string => {
    let result = '';
    if (!stateCode) { return result; }

    switch (stateCode) {
        case BidLetterStateCodes.Utah:
            result = 'Utah';
            break;

        case BidLetterStateCodes.California:
            result = 'California';
            break;

        case BidLetterStateCodes.Arizona:
            result = 'Arizona';
            break;

        case BidLetterStateCodes.Nevada:
        default:
            result = 'Nevada';
            break;
    }

    return result;
};



// WEBPACK FOOTER //
// ./src/order/order-common.tsx